import React from 'react';
import { Dropdown as AntdDropdown } from 'antd';
import { DropDownProps as AntdDropDownProps } from 'antd/lib/dropdown';
import { LayoutContext } from 'contexts';

export type DropDownProps = AntdDropDownProps;

export const Dropdown: React.FC<AntdDropDownProps> = ({
  className,
  getPopupContainer,
  ...props
}) => {
  const layout = React.useContext(LayoutContext);

  const getContainerFunction = () => {
    if (getPopupContainer) return getPopupContainer;
    if (layout?.scrollContainer) return () => layout.scrollContainer;
    return undefined;
  };

  return (
    <AntdDropdown
      {...props}
      overlayClassName={className}
      getPopupContainer={getContainerFunction()}
    />
  );
};

export default Dropdown;
